var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"color":"transparent","elevation":"0","fixed":""}},[_vm._t("left"),_c('v-spacer'),_c('div',{staticClass:"title text-overline font-weight-medium text-truncate text-uppercase grey--text px-3"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]),_c('v-spacer'),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }